import { Requirement } from "@siteimprove/alfa-act";
import { Techniques } from "./technique/data.js";
/**
 * @public
 */
export class Technique extends Requirement {
    static of(name) {
        return new Technique(name, Techniques[name].uri);
    }
    _name;
    _title;
    constructor(name, uri) {
        super("technique", uri);
        this._name = name;
        this._title = Techniques[name].title;
    }
    /**
     * The name of this technique.
     */
    get name() {
        return this._name;
    }
    /**
     * The title of this technique.
     */
    get title() {
        return this._title;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            name: this._name,
            title: this._title,
        };
    }
    toEARL() {
        return {
            ...super.toEARL(),
            "@context": {
                earl: "http://www.w3.org/ns/earl#",
                dct: "http://purl.org/dc/terms/",
            },
            "dct:title": this._title,
            "dct:isPartOf": "https://www.w3.org/WAI/WCAG21/Techniques/",
        };
    }
}
/**
 * @public
 */
(function (Technique) {
    function isName(value) {
        return value in Techniques;
    }
    Technique.isName = isName;
    function isTechnique(value) {
        return value instanceof Technique;
    }
    Technique.isTechnique = isTechnique;
})(Technique || (Technique = {}));
//# sourceMappingURL=technique.js.map